import Image from "next/image";
import Link from "next/link";
import { storyblokEditable } from "@storyblok/react/rsc";

import { getUrlFromLinkObject } from "@/lib/storyblok/utils";
import type { InstagramLinkItemStoryblok } from "@/component-types-sb";

type InstagramLinkItemProps = {
  blok: InstagramLinkItemStoryblok;
};

const InstagramLinkItem = ({ blok }: InstagramLinkItemProps) => {
  const href = getUrlFromLinkObject(blok.link) || "#";

  return (
    <Link
      href={href}
      target={blok.link?.target || "_self"}
      className="relative aspect-square overflow-hidden"
      {...storyblokEditable(blok)}
    >
      <Image
        src={blok.image.filename}
        alt={blok.image.alt || ""}
        fill
        sizes="(max-width: 480px) 33vw, 160px"
        className="object-cover"
      />
    </Link>
  );
};

export default InstagramLinkItem;
